<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="关键字" prop="keyword">
        <Input v-model="formValidate.keyword" type="textarea" placeholder="请输入关键字，多个关键字用;隔开"></Input>
      </FormItem>
      
      <FormItem label="所属分类"  prop="classify_id" v-if="classifyIds.length > 1">
        <Select v-model="formValidate.classify_id">
          <Option
            v-for="item in classifyIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="所属平台"  prop="live_id" >
        <Select v-model="formValidate.live_id">
          <Option
            v-for="item in liveIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>


      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyIds: [],
      liveIds: [],
      formValidate: {
        id: '',
        keyword: '',
        classify_id: 0,
        live_id:0
      },
      ruleValidate: {
        keyword: [
          {
            required: true,
            message: '关键字不能为空',
            trigger: 'blur'
          }
        ],
        classify_id: [
          {
            required: true,
            message: '所属分类必须要选择',
            trigger: 'change'
          }
        ],
        live_id: [
          {
            required: true,
            message: '所属平台必须要选择',
            trigger: 'change'
          }
        ],
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setEditData (data) {
      this.formValidate.id = data.id
      this.formValidate.keyword = data.keyword
      this.formValidate.classify_id = data.classify_id.toString()
      this.formValidate.live_id = data.live_id.toString()
    }, 
    setData (classifyIds, liveIds) {
      this.classifyIds = classifyIds
      this.liveIds = liveIds
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
